import { render, staticRenderFns } from "./MediaOwnerScreenTags.vue?vue&type=template&id=968688e0&"
import script from "./MediaOwnerScreenTags.vue?vue&type=script&lang=js&"
export * from "./MediaOwnerScreenTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports